import React, {useState} from 'react'
import {Collapse, makeStyles} from "@material-ui/core";
import MembersElementTitle from "./TemplateMembersElementTitle";
import TemplateMembersElementContent from "./TemplateMembersElementContent";
import PropTypes from "prop-types";
import {simpleConfirm} from "libs/ConfirmNotification";
import {connect} from "react-redux";

const useStyle = makeStyles(theme => ({
    root: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper,
        padding: `${theme.spacing()}px ${theme.spacing(2)}px`,
        marginBottom: theme.spacing()
    }
}))

function TemplateMembersElement(
    {
        index,
        groupId,
        member,
        coordinatorView,
        editable,
        search,
        validationSection,
        formIdPrefix,
        formValues
    }) {
    const classes = useStyle();
    const [open, setOpen] = useState(false);
    const FORM_ID = formIdPrefix + member.memberId;

    const toggleMember = () => {
        if (open && !!formValues[FORM_ID + "_dirty"]) {
            simpleConfirm("modification_cancel_popup_text", () => {
                setOpen(!open)
            })
        } else {
            setOpen(!open)
        }
    }


    return (<Collapse in={!search.search || member.memberName.toLowerCase().indexOf(search.search.toLowerCase()) > -1} unmountOnExit={false}>
        <div className={classes.root}>
            <MembersElementTitle
                groupId={groupId}
                editable={editable}
                index={index}
                member={member}
                open={open}
                onOpen={toggleMember}
                coordinatorView={coordinatorView}
                validationSection={validationSection}
            />
            <Collapse in={coordinatorView || open} unmountOnExit>
                <TemplateMembersElementContent
                    groupId={groupId}
                    member={member}
                    coordinatorView={coordinatorView}
                    editable={editable}
                    validationSection={validationSection}
                    uxFormId={FORM_ID}

                />
            </Collapse>
        </div>
    </Collapse>)
}

TemplateMembersElement.propTypes = {
    index: PropTypes.number,
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    member: PropTypes.shape({
        allFormsAccepted: PropTypes.bool.isRequired,
        memberId: PropTypes.number.isRequired,
        memberName: PropTypes.string.isRequired
    }),
    coordinatorView: PropTypes.bool.isRequired,
    editable: PropTypes.bool.isRequired,
    search: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    validationSection: PropTypes.object.isRequired,
    formIdPrefix: PropTypes.string.isRequired,
}

export default connect((state) => ({
    formValues: state.formValues
}), {})(TemplateMembersElement);